import React from 'react';
import type { CustomArtProps } from './CustomArt.types';
import { Box } from '@withjoy/joykit';
import { backgroundImageForUrl } from '@shared/utils/style/backgroundImage';

export const CustomArt: React.FC<CustomArtProps> = ({ backgroundImageUrl }) => {
  if (!backgroundImageUrl) {
    return null;
  }

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height="100vh"
      transform="translate(0px)"
      pointerEvents="none"
    >
      <Box
        width="100%"
        height="100%"
        position="absolute"
        backgroundSize="cover"
        backgroundImage={backgroundImageForUrl(backgroundImageUrl)}
        backgroundRepeat="no-repeat"
        backgroundPosition="center center"
      />
    </Box>
  );
};

CustomArt.displayName = 'CustomArt';
